import type { CreateClientConfig } from "./generated/client.gen.ts";

// Generated SDK paths already include the `/api/v1` prefix (matches the API's
// `basePath`). baseUrl must NOT duplicate that — keep it empty so URLs resolve
// against the current origin (Vite proxy in dev, same-origin in prod).
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: "",
  credentials: "include",
});
